import { CreateOrEditDeploymentTargetTriggerPage } from "./CreateOrEditDeploymentTargetTriggerPage";
export interface DeploymentTargetTriggerPageProps {
    spaceId: string;
    projectSlug: string;
    triggerId: string;
}
export function DeploymentTargetTriggerPage({ spaceId, projectSlug, triggerId }: DeploymentTargetTriggerPageProps) {
    return <CreateOrEditDeploymentTargetTriggerPage spaceId={spaceId} projectSlug={projectSlug} triggerId={triggerId}/>;
}
